<template>
  <v-app class="layout-auth primary">
    <v-main>
       <el-system-info class="system-info-login" />
      <v-container style="padding-top: 10%" class="page-login" >
        <v-row>
          <v-col>
            <v-card class="pa-3 page-login__card" tile>
              <v-card-title>
                <h1 class="primary--text display-1 page-login_title">ĮREG</h1>
              </v-card-title>
              <v-card-text>
                <template v-if="isLocal">
                  <v-form
                    ref="form"
                    class="my-0"
                    lazy-validation
                    v-model="formValid"
                  >
                    <v-row no-gutters align="end">
                      <v-col cols="12" class="pt-3 mb-2">
                        <el-autocomplete
                          :items="usersList"
                          hide-details
                          direct
                          itemvalue="value"
                          itemtext="text"
                          label="Naudotojas"
                          v-model="formModel.username"
                        />
                      </v-col>
                      <v-col cols="12" class="text-center mb-2">
                        <el-button
                          large
                          tile
                          class="iPasasLogin"
                          color="primary"
                          @click.native="localLogin"
                          :loading="loading"
                          title="Prisijungti"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </template>
                <template v-if="!isLocal">
                  <v-row no-gutters>
                    <v-col cols="12" class="text-center my-3">
                      <el-button
                        class="iPasasLogin"
                        color="primary"
                        @click.native="iPasasLogin"
                        :loading="loading"
                        title="Prisijungti per iPasas.lt"
                      />
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
              <v-card-actions style="place-content: center">
                <img
                  :src="computeRCLogo"
                  class="rclogo"
                  alt="Registrų centras"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer class="login-footer">
      Darbui su ĮREG naudotinos šios naršyklės: Mozilla Firefox (nuo 88
      versijos), Google Chrome (nuo 91 versijos), Edge (nuo 91 versijos).<br />
      Rekomenduojama ekrano rezoliucija yra nuo 1024x768 iki 1920x1080,
      priartinimas - 100%
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'login',
  mixins: [userRole],
  data() {
    return {
      loading: false,
      formValid: false,
      usersList: [],
      formRule: {
        username: [(v) => !!v || 'laukas privalomas'],
      },
      formModel: {
        username: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userAgreement', 'appSavitarna']),
    prefix() {
      return ''
    },
    computeRCLogo() {
      return '/static/rclogo.png'
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
    isPreprod() {
      return process.env.VUE_APP_PREPROD === 'true'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    iPasasUrl() {
      return process.env.VUE_APP_IPASAS_URL
    },
  },
  created() {
    this.$store.dispatch('loadNotifications')
    this.getNotification()
    if (this.isLocal) {
      this.$axios.get('local/login-users/' + (this.isSavitarna ? 'savitarna' : 'ireg')).then(res => {
        this.usersList = res.data
      })
    }
  },
  methods: {
    getNotification() {
      this.$axios.get(`system-notifications/application/ireg`).then((res) => {
        this.$store.dispatch('systemNotification', res.data)
      })
    },
    localLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('localLogin', this.formModel)
          .then(() => {
            this.$store.dispatch('loadTooltips')
            this.$store.dispatch('changeLanguage', {
              lang: 'lt',
              i18n: this.$i18n,
            })
            this.loading = false
            // if (!this.userAgreement) {
            //   this.$router.push({ name: 'agreement' })
            // }
            this.$router.push({ name: 'home' })
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    iPasasLogin() {
      this.loading = true
      window.location.href = this.iPasasUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.system-info-login{
  position: relative;
  top: 0px;
  width: 100%;
  left: 0px;
}

.page-login {
  &__card {
    max-width: 400px;
    margin: 0 auto;
  }
}
.layout-auth {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}
.rclogo {
  max-width: 150px;
}

.iPasasLogin {
  width: 80%;
}

.login-footer {
  background: none;
  color: #aeaeae;
  font-size: 0.8rem;
  text-align: end;
  display: inline-block;
}
</style>
